import { Injectable } from "@angular/core";
import { Http, RequestOptions, Response, Headers } from "@angular/http";
import { Observable } from "rxjs/Rx";
import { apiUrl } from "./../../config";

import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";

@Injectable()
export class LocationsService {
  constructor(private http: Http) {}

  saveLocations(data: any): Observable<any> {
    var url = apiUrl + "/savelocations";
    // var url = 'http://localhost/deutz1/public/savelocations';
    var d = JSON.stringify(data);
    const body = "data=" + encodeURIComponent(d);

    const headers: Headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");

    const options = new RequestOptions({
      headers: headers
    });

    return this.http.post(url, body, options).map(res => {
      return res.json();
    });
  }

  deleteLocations(id: any) {
    var url = apiUrl + "/deletelocations";
    // const url = "http://localhost/deutz1/public/deletelocations";
    const body = "data=" + id;

    const headers: Headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");

    const options = new RequestOptions({
      headers: headers
    });
    return this.http.post(url, body, options).map(res => {
      const data = res.json();
      return data;
    });
  }

  editLocations(id: any): Observable<any> {
    var url = apiUrl + "/editlocation";
    //var url = 'http://localhost/deutz1/public/editlocation';
    const body = "data=" + id;
    const headers: Headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");

    const options = new RequestOptions({
      headers: headers
    });

    return this.http.post(url, body, options).map(res => {
      return res.json();
    });
  }

  getlocations() {
    var url = apiUrl + "/alllocations";
    //const url = "http://localhost/deutz1/public/alllocations";

    return this.http.get(url).map(res => {
      return res.json();
    });
  }

  getServiceProviderType() {
    var url = apiUrl + "/serviceProviderType";
    // const url = "http://localhost/deutz1/public/serviceProviderType";
    return this.http.get(url).map(res => {
      return res.json();
    });
  }

  getbrands() {
    var url = apiUrl + "/allbrands";
    //const url = "http://localhost/deutz1/public/allbrands";
    return this.http.get(url).map(res => {
      return res.json();
    });
  }

  getcountries() {
    var url = apiUrl + "/countries";
    // const url = "http://localhost/deutz1/public/countries";
    return this.http.get(url).map(res => {
      return res.json();
    });
  }

  exceldownload() {
    var url = apiUrl + "/downloadLocationExcel";
    //const url = "http://localhost/deutz1/public/downloadLocationExcel";
    return this.http.get(url).map(res => {
      return res.json();
    });
  }
}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_services/locations/locations.service.ts